import styled, { css } from 'styled-components';

import { RegistrationStatus } from '__generated__/graphql';

import { ComponentProps, ReactNode } from 'react';
import { UIProps } from '../../theme/mixins';
import SC from '../UI/SC';
import UI from '../UI';

interface SellableLabelProps {
  type?: 'ticket' | 'product';
  status?: RegistrationStatus;
}

const SellableLabel = styled(UI.Label)<SellableLabelProps & SC<UIProps>>`
  ${({ type = 'ticket', theme }) => css`
    ${type === 'ticket' && css`
      background: ${theme.getColor('secondary.75')};
      color: ${theme.getColor('secondary.600')};
    `}
    ${type !== 'ticket' && css`
      color: ${theme.getColor('gray.800')};
    `}
    font-size: ${12 / 14}em;
    font-weight: 500;
  `}
`;

interface TicketLabelProps extends ComponentProps<typeof SellableLabel> {
  ticket?: string;
  status?: RegistrationStatus;
  children?: ReactNode;
}

export const TicketLabel = ({ ticket, status, children, ...props }: TicketLabelProps) => (
  <SellableLabel {...props}>
    <UI.Icon>
      <UI.Icons.Ticket />
    </UI.Icon>
    {' '}
    {children || ticket}
  </SellableLabel>
);

export default SellableLabel;
